import DuaPart from '@components/DuaPage/DuaPart'

const DuaSampleData = {
  arab: 'يَا مَنْ لَهُ الْقُدْرَةُ وَ الْكَمَالُ',
  meal: 'Ey kudret ve kemâlin gerçek sahibi,',
  latin: 'Ya men lahul qudratu vel kamâl',
  no: 32,
}

const DuaSample = () => {
  return (
    <DuaPart partKey={0} page={1} type="cevsen" isLastItem={false} part={DuaSampleData} />
  )
}

export default DuaSample
